module.exports = __webpack_public_path__ + "static/media/PL.f24daa72.svg";